import { LogSeverity } from '@lib.core/logger/logger.service';

export const environment = {
  ecdevManageApiBaseUrl: 'https://ecdev-manage-test.azurewebsites.net/api',
  defaultConsoleMinLoggingLevel: LogSeverity.Warning,
  vectorTileBaseUrl: 'https://maps.ecdev-internal.org/vector-tile/localintel',
  matomo: {
    enabled: false,
    siteId: '',
    trackerUrl: '',
    scriptUrl: ''
  },
};
